// Modules
import keys from 'lodash/keys'
import { createSelector } from 'reselect'

// Store
import { findElemInListCurrency } from 'utils/findElemInListCurrency'

import {
  currencyListSelector,
  currencyListUpdatedSelector,
} from 'store/actions/CurrencySocket/selectors'
import { favouritesCurrencyListSelector } from 'store/actions/FavouritesCurrency/selectors'

export const titlesAccordionSelector = createSelector([currencyListSelector], (list) =>
  list ? keys(list) : [],
)

export const updatedFavouritesSelector = createSelector(
  [favouritesCurrencyListSelector, currencyListUpdatedSelector],
  (favouritesTrade, list) => {
    return favouritesTrade?.map((el) => {
      const updatedItem = findElemInListCurrency(el?.name, list)
      if (updatedItem) {
        return { ...el, price: updatedItem?.price, spread: updatedItem?.spread }
      } else {
        return el
      }
    })
  },
)
